export enum PortalSelector {
  ADD_TO_HOME_SCREEN = 'add-to-home-screen-portal',
  PP_PORTAL = 'pp-portal',
}

const portalsSelectors = [
  PortalSelector.ADD_TO_HOME_SCREEN,
  PortalSelector.PP_PORTAL,
];

export default portalsSelectors;
